import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-baab08f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row col-12" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = { class: "d-flex gap-3 g-2" }
const _hoisted_4 = { class: "btn btn-sm btn-light-primary fs-4 rounded-pill" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-menu-button-wide-fill fs-3" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-down" }, null, -1))
const _hoisted_7 = { class: "d-flex flex-column gap-3 g-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fs-7 fw-bold mb-2" }, "فیلتر ادمین ", -1))
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "symbol symbol-20px symbol-circle me-5" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_13 = { class: "mb-1 fs-7" }
const _hoisted_14 = {
  class: "text-grey-500",
  dir: "ltr"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fs-7 fw-bold mb-2" }, "فیلتر مشتری ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fs-7 fw-bold mb-2" }, "فیلتر برچسب ", -1))
const _hoisted_17 = { class: "d-flex justify-content-end flex-wrap flex-stack mb-5" }
const _hoisted_18 = {
  class: "nav nav-pills",
  role: "tablist"
}
const _hoisted_19 = {
  class: "nav-item m-0",
  role: "presentation"
}
const _hoisted_20 = { class: "svg-icon svg-icon-2" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" مدیریت بورد ها ")
const _hoisted_22 = {
  class: "row d-flex flex-row flex-nowrap scroll-x scroll-me pb-2 rounded min-h-100px",
  style: {"overflow-y":"hidden !important"}
}
const _hoisted_23 = ["id"]
const _hoisted_24 = { class: "d-flex justify-content-between align-items-center border-bottom border-bottom-dashed border-gray-500 py-2 mb-2" }
const _hoisted_25 = { class: "text-gray-700" }
const _hoisted_26 = { class: "text-gray-700" }
const _hoisted_27 = { class: "text-gray-500 ms-1" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2-all" }, null, -1))
const _hoisted_29 = { class: "text-gray-500 ms-1" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clock-fill" }, null, -1))
const _hoisted_31 = ["href"]
const _hoisted_32 = ["id"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["id"]
const _hoisted_35 = {
  class: "scroll-y",
  style: {"overflow-x":"hidden !important","height":"70vh !important"}
}
const _hoisted_36 = { class: "card card-body rounded position-relative mx-1 note-box mb-2 p-2 border border-dashed border-gray-400 bg-light pointer-event" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "fs-7 fw-bold text-gray-800 d-flex align-items-center" }
const _hoisted_39 = ["title"]
const _hoisted_40 = ["src"]
const _hoisted_41 = { class: "ms-2 my-auto" }
const _hoisted_42 = {
  key: 0,
  class: "fs-8 fw-semobold text-gray-600 mb-2"
}
const _hoisted_43 = {
  key: 1,
  class: ""
}
const _hoisted_44 = ["src"]
const _hoisted_45 = { class: "d-flex align-items-center mt-1 fs-6 justify-content-end" }
const _hoisted_46 = ["title"]
const _hoisted_47 = {
  key: 0,
  class: "text-gray-400"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi fs-7 bi-chat me-1" }, null, -1))
const _hoisted_49 = {
  key: 1,
  class: "text-gray-400"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi fs-7 bi-tag me-1" }, null, -1))
const _hoisted_51 = {
  key: 2,
  class: "text-gray-400"
}
const _hoisted_52 = { class: "text-gray-400" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi fs-7 bi-clock me-1" }, null, -1))
const _hoisted_54 = {
  key: 3,
  class: "symbol-group flex-nowrap symbol-hover"
}
const _hoisted_55 = ["title"]
const _hoisted_56 = ["src"]
const _hoisted_57 = {
  key: 4,
  class: "symbol-group symbol-hover flex-nowrap"
}
const _hoisted_58 = ["src"]
const _hoisted_59 = {
  key: 5,
  class: "symbol-group symbol-hover flex-nowrap"
}
const _hoisted_60 = ["title"]
const _hoisted_61 = ["src"]
const _hoisted_62 = { key: 6 }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-grip-vertical fs-5 mx-2 handle text-hover-primary cursor-move hoverable",
  style: {"cursor":"grab"}
}, null, -1))
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye" }, null, -1))
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = {
  class: "note-action-btn position-absolute translate-middle btn btn-sm btn-light-danger btn-icon w-25px h-25px",
  style: {"top":"5%","right":"69%"}
}
const _hoisted_69 = { class: "svg-icon svg-icon-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_NoteBody = _resolveComponent("NoteBody")!
  const _component_CategoryList = _resolveComponent("CategoryList")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_dropdown, null, {
            dropdown: _withCtx(() => [
              (_ctx.boardsList)
                ? (_openBlock(), _createBlock(_component_el_dropdown_menu, { key: 0 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.boardsList, (board, i) => {
                        return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                          key: i,
                          onClick: ($event: any) => (_ctx.activeBoardId = board.id)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(board.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_4, [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.activeBoardInfo?.title) + " ", 1),
                _hoisted_6
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_popover, {
            teleported: "true",
            placement: "bottom",
            width: 320,
            trigger: "click",
            visible: _ctx.popoverVisible.assign_admins
          }, {
            reference: _withCtx(() => [
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-sm btn-icon btn-light btn-circle btn-color-muted btn-active-primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (
                _ctx.popoverVisible.assign_admins = !_ctx.popoverVisible.assign_admins
              ))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(["bi fs-3", [
                  !_ctx.popoverVisible.assign_admins
                    ? 'bi-filter'
                    : 'bi-x fs-2x animation-blink text-danger',
                ]])
                }, null, 2)
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _hoisted_8,
                  _createVNode(_component_el_select, {
                    size: "small",
                    multiple: "",
                    filterable: "",
                    remote: "",
                    "reserve-keyword": "",
                    "collapse-tags": "",
                    modelValue: _ctx.filter.assign_admins,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter.assign_admins) = $event)),
                    placeholder: "جستجوی کاربر",
                    loading: _ctx.loadingSearchUser,
                    "loading-text": "در حال جستجو ...",
                    "remote-method": _ctx.performSearch,
                    id: "searchAdmin"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.admins, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: index,
                          label: item.full_name,
                          value: item.id
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("img", {
                                  src: item?.picture ?? `media/avatars/blank.png`,
                                  alt: ""
                                }, null, 8, _hoisted_11)
                              ]),
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("span", _hoisted_13, [
                                  _createTextVNode(_toDisplayString(item?.first_name + " " + item?.last_name) + " ", 1),
                                  _createElementVNode("span", _hoisted_14, "( " + _toDisplayString(item?.mobile) + " ) ", 1)
                                ])
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "loading", "remote-method"])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_15,
                  _createVNode(_component_el_select, {
                    size: "small",
                    multiple: "",
                    filterable: "",
                    remote: "",
                    "reserve-keyword": "",
                    "collapse-tags": "",
                    modelValue: _ctx.filter.for_customers,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filter.for_customers) = $event)),
                    placeholder: "جستجوی کاربر",
                    loading: _ctx.loadingSearchUser,
                    "loading-text": "در حال جستجو ...",
                    "remote-method": _ctx.performSearch,
                    id: "searchAdmin"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: index,
                          label: `${item.first_name} ${item.last_name}`,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "loading", "remote-method"])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_16,
                  _createVNode(_component_el_select, {
                    size: "small",
                    modelValue: _ctx.filter.tags,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filter.tags) = $event)),
                    multiple: "",
                    "allow-create": "",
                    "default-first-option": "",
                    placeholder: "برچسب را وارد کنید"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_el_checkbox, {
                    modelValue: _ctx.filter.only_my_tasks,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filter.only_my_tasks) = $event)),
                    label: "فقط وظایف من نمایش داده شوند ؟",
                    size: "small",
                    border: ""
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["visible"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("ul", _hoisted_18, [
            _createElementVNode("li", _hoisted_19, [
              _createElementVNode("button", {
                class: "btn btn-sm rounded-pill text-nowrap btn-light-linkedin d-flex flex-center ms-3 mb-3 mb-md-0 px-4 py-3 btn-hover-scale",
                type: "button",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialogVisible = true))
              }, [
                _createElementVNode("span", _hoisted_20, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr077.svg" })
                ]),
                _hoisted_21
              ])
            ])
          ])
        ])
      ])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_22, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "w-300px min-w-200px mw-350px p-0 ms-1",
          key: i
        }, [
          _createElementVNode("div", {
            class: "card card-body bg-transparent border border-dashed border-gray-400 p-3 rounded",
            id: cat.id
          }, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("h5", _hoisted_25, _toDisplayString(cat.name), 1),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("span", _hoisted_27, [
                  _createTextVNode(_toDisplayString(_ctx.getCategoryTasks(cat.id).length) + " ", 1),
                  _hoisted_28
                ]),
                _createElementVNode("span", _hoisted_29, [
                  _createTextVNode(_toDisplayString(_ctx.categoryTasksDurations(cat.id)) + " ", 1),
                  _hoisted_30
                ]),
                _createElementVNode("a", {
                  class: "btn btn-sm btn-light bg-transparent btn-icon btn-circle",
                  download: "",
                  href: _ctx.downloadCategoryExcel(cat.id)
                }, [
                  _createElementVNode("i", {
                    class: "fas fa-file-excel fs-5 mx-2",
                    id: cat.id
                  }, null, 8, _hoisted_32)
                ], 8, _hoisted_31),
                _createElementVNode("button", {
                  class: "btn btn-sm btn-light bg-transparent btn-icon btn-circle",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#kt_modal_create_task_modal",
                  onClick: ($event: any) => (_ctx.activeCategoryId = cat.id)
                }, [
                  _createElementVNode("i", {
                    class: "fas fa-plus fs-5 mx-2",
                    id: cat.id
                  }, null, 8, _hoisted_34)
                ], 8, _hoisted_33)
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_draggable, {
                handle: ".handle",
                list: _ctx.getCategoryTasks(cat.id),
                group: "people",
                onChange: _ctx.log,
                onUpdate: _ctx.update,
                itemKey: cat.name,
                onMove: _ctx.move,
                class: "mt-2",
                style: {"min-height":"50vh !important"},
                id: cat.id
              }, {
                item: _withCtx(({ element }) => [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", {
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#kt_modal_note_body",
                      onClick: ($event: any) => (_ctx.setTargetTodoId(element.id))
                    }, [
                      _createElementVNode("div", _hoisted_38, [
                        (element.creator)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "symbol symbol-circle symbol-20px",
                              "data-bs-toggle": "tooltip",
                              "data-bs-boundary": "window",
                              "data-bs-placement": "top",
                              title: `ایجاد کننده : ${element.creator.first_name} ${element.creator.last_name}`
                            }, [
                              _createElementVNode("img", {
                                src: element.creator.picture,
                                alt: "img"
                              }, null, 8, _hoisted_40)
                            ], 8, _hoisted_39))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", _hoisted_41, _toDisplayString(element.title), 1)
                      ]),
                      (element.description)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(element.description.length > 73
                        ? element.description.substring(0, 70) + "..."
                        : element.description), 1))
                        : _createCommentVNode("", true),
                      (element.thumbnail)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _createElementVNode("img", {
                              src: element.thumbnail,
                              class: "img-fluid img-thumbnail"
                            }, null, 8, _hoisted_44)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_45, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.extra_fields, (extra, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: i,
                            class: "text-gray-400"
                          }, [
                            (extra.field === 'call')
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  class: _normalizeClass(["bi fs-7 me-1", [
                            `${
                              extra.value === 'customer'
                                ? 'bi-telephone-inbound-fill text-success'
                                : ''
                            }`,
                            `${
                              extra.value === 'company'
                                ? 'bi-telephone-outbound-fill text-primary'
                                : ''
                            }`,
                          ]]),
                                  title: ` تماس از طرف ${_ctx.translate(extra.value)}`
                                }, null, 10, _hoisted_46))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128)),
                        (element.comment_count > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                              _createTextVNode(_toDisplayString(element.comment_count), 1),
                              _hoisted_48
                            ]))
                          : _createCommentVNode("", true),
                        (element.tags && element.tags.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                              _createTextVNode(_toDisplayString(element.tags.length), 1),
                              _hoisted_50
                            ]))
                          : _createCommentVNode("", true),
                        (element.duration)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                              _createElementVNode("span", _hoisted_52, _toDisplayString(element.duration), 1),
                              _hoisted_53
                            ]))
                          : _createCommentVNode("", true),
                        (element.customers_count > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.for_customers, (customer, j) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "symbol symbol-20px ms-1 symbol-circle",
                                  key: j,
                                  "data-bs-toggle": "tooltip",
                                  "data-bs-boundary": "window",
                                  "data-bs-placement": "top",
                                  title: `مشتری : ${customer.first_name} ${customer.last_name}`
                                }, [
                                  _createElementVNode("img", {
                                    alt: "Pic",
                                    src: customer.picture
                                  }, null, 8, _hoisted_56)
                                ], 8, _hoisted_55))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.platformsList && element.platforms !== null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.platforms, (plat, p) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "symbol symbol-20px symbol-circle",
                                  style: {"margin-right":"2px !important"},
                                  key: p
                                }, [
                                  _createElementVNode("img", {
                                    alt: "Pic",
                                    src: _ctx.platformsList[plat].logo
                                  }, null, 8, _hoisted_58)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (element.assign_admins.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.assign_admins, (userAdmin, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "symbol symbol-20px symbol-circle",
                                  style: {"margin-right":"2px !important"},
                                  key: index,
                                  "data-bs-toggle": "tooltip",
                                  "data-bs-boundary": "window",
                                  "data-bs-placement": "top",
                                  title: `ادمین : ${userAdmin.first_name} ${userAdmin.last_name}`
                                }, [
                                  _createElementVNode("img", {
                                    alt: "Pic",
                                    src: userAdmin.picture
                                  }, null, 8, _hoisted_61)
                                ], 8, _hoisted_60))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (element.editable)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_62, _hoisted_64))
                          : _createCommentVNode("", true)
                      ])
                    ], 8, _hoisted_37),
                    _createElementVNode("button", {
                      class: "note-action-btn position-absolute translate-middle btn btn-sm btn-light-primary btn-icon w-25px h-25px",
                      style: {"top":"5%","right":"85%"},
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#kt_modal_note_body",
                      onClick: ($event: any) => (_ctx.setTargetTodoId(element.id))
                    }, _hoisted_67, 8, _hoisted_65),
                    _createVNode(_component_el_popconfirm, {
                      "confirm-button-text": _ctx.translate('yes'),
                      "cancel-button-text": _ctx.translate('cancel'),
                      "icon-color": "#626AEF",
                      title: _ctx.translate('Are you sure you want to delete this'),
                      onConfirm: ($event: any) => (_ctx.deleteTodo(element.id))
                    }, {
                      reference: _withCtx(() => [
                        _createElementVNode("button", _hoisted_68, [
                          _createElementVNode("span", _hoisted_69, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen027.svg" })
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["confirm-button-text", "cancel-button-text", "title", "onConfirm"])
                  ])
                ]),
                _: 2
              }, 1032, ["list", "onChange", "onUpdate", "itemKey", "onMove", "id"])
            ])
          ], 8, _hoisted_23)
        ]))
      }), 128))
    ])), [
      [_directive_loading, _ctx.loadingCategory]
    ]),
    _createVNode(_component_NoteBody, { ref: "notBodyModal" }, null, 512),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      "custom-class": "w-100 w-md-75"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CategoryList)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}